import React, { useEffect, useState } from "react";

// <------- MUI Components  ---------->
import { Divider } from "@mui/material";

// <------ React-bootstrap Components ------->
import { Col, Row } from "react-bootstrap";

// Redux Hooks
import { useDispatch, useSelector } from "react-redux";

// <-------  Components  ---------->
import ProductCard from "../../../components/Forms/ProductCard";
import ButtonWithDownArrow from "components/Buttons/ButtonWithArrow";

// Actions
import { selectProduct } from "store/actions/products";


const Step2 = ({ handleNext, handleBack }) => {

    // Selectors from Store
    const productOptions = useSelector(state => state.products?.productOptions?.productOptions);
    const product = useSelector(state => state.products?.productOptions?.product);

    // Redux Hooks
    const dispatch = useDispatch();
 
    // Dispatching selected products
    const handleSelectQuote = (evt) => {
        console.log('selected evt-->',evt)
      try{
        dispatch(
            selectProduct(
                evt
            )
        )
        handleNext(2);
      }
      catch (err) {}
    }

    const [options, setOptions] = useState([]);

    const getProrate = (string, name) => {
        const arr = string.split(",");
        let obj = {};
        arr.forEach((a) => { const val = a.split(":");obj[val[0]] = val[1];})
        return obj;
    }

    useEffect(() => {
        var  valuations = productOptions && productOptions[0];
        var arr = [
            { 
                type: 'Monthly',
                price: valuations.rating.total,
                description: 'Monthly Premium Amount'
            },{
                type: 'Annually',
                price: parseFloat( getProrate(valuations.risks && valuations.risks[0].rating.message, '').annualPremium),
                description: 'Annual Premium Amount'
            }
        ].map((ex) => ({ ...valuations, name: `SureThing ${ex.type}`, rating: {...valuations.rating, total: ex.price }, des: ex.description }))
        setOptions(arr);
        // eslint-disable-next-line react-hooks/exhaustive-deps
     },[])


    const limitOfIndemnityFormatter = (value) => {
        const split = value.split('-');
        return `R ${parseFloat(split[0].replaceAll(" ","")).toLocaleString("fi-FI").replaceAll(",",".")} - R ${parseFloat(split[1]).toLocaleString("fi-FI").replaceAll(",",".")}`
    }

    return (
        <div>
            {/* <---------- Title -------> */}
            <h4>{product?.name}</h4>

            {/* <------- Sub title ------> */}
            <h6>Select a quote</h6>

            <Divider row={2} />
            {/* <------- Product Cards Starts ------> */}
            <Row >
                 {options
                 .map((ele, index) =>
                    <Col key={index} sm={6} className="mb-5 mt-3" >
                        <ProductCard
                             title={ele.name}
                             sub={ele.des}
                             price={`R ${ele.rating.total.toString().includes('.') ? parseFloat(ele.rating.total.toFixed(2)).toLocaleString("fi-FI").replaceAll(",",".") 
                                        :
                                        `${parseFloat(ele.rating.total).toLocaleString("fi-FI").replaceAll(",",".")}.00`
                                    } ${ele.name.toLowerCase().includes('monthly') ? 'pm' : 'pa'}`} // For credit  --->   annualPremium
                             turnover={ele.body.risks && ele.body.risks[0].attributes.find((f) => f.name.toLowerCase().includes('annual'))?.value}
                             excess={`R ${options?.length > 0 && getProrate(options?.length > 0 && options[0].risks.length && options[0]?.risks[0].rating.message) ? parseFloat(options?.length > 0 && getProrate(options?.length > 0 && options[0].risks.length && options[0]?.risks[0].rating.message)?.Excess).toLocaleString("fi-FI").replaceAll(",",".") : '15 000'}`}
                             onPress={() => handleSelectQuote(ele)}
                             description={ele.description}

                             limit={limitOfIndemnityFormatter(getProrate(ele.risks[0] && ele.risks[0].rating.message, ele.name)['Limit of Indemnity'])}

                             //Limit of Indemnity
                        />
                    </Col>
                )}
            </Row>

            {/* <------- Product Cards Ends ------> */}

            {/* <------- Navigator button starts ------> */}
            <Row className="mt-5">
                <Col sm={2}>
                    <ButtonWithDownArrow
                         onClick={handleBack}
                         type="left"
                         name="Back"
                         bg="#dd302a"
                         color="white"
                         id="form-2-back-button"
                    />
                </Col>
                <Col sm={10}>
                    <div className="info">
                        {/* * Aggregate Limit of indemnity R 1 000 000 - R 5 000 0000 <br/> */}
                        * Excess applicable for 3rd party claims only
                    </div>
                </Col>
            </Row>
            {/* <------- Navigator button ends ------> */}
        </div>
    )
}

export default Step2;
